<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="property_names"
      ref="soucePage"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class Propertynames extends Vue {

  pagination = {}

  filter = []

  table = {
    data: [],
    events: {
      'row-click': (row) => {
        const tableComponent = this.$refs.soucePage.getTableComponent();
        tableComponent.toggleRowExpansion(row);
      }
    }
  };

  get columns() {
    return createColumns(this)
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/property_names', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
